import * as React from "react";

import {
  useProductListPresentationModel,
  usePlpPresenterForTheFilterMenu_Desktop,
} from "../providers";
import { DesktopSorting } from "../desktop-sorting";

export const DesktopActionBar: React.FunctionComponent = () => {
  const { productCount } = useProductListPresentationModel();

  const {
    shouldShowTheFilterMenu_onDesktop,
    handleTogglingTheFilterMenu_onDesktop,
  } = usePlpPresenterForTheFilterMenu_Desktop();

  return (
    <div className="desktop-action-bar">
      <div className="content">
        <div className="left">
          <button
            className="filter-action"
            onClick={handleTogglingTheFilterMenu_onDesktop}
          >
            <p>
              {shouldShowTheFilterMenu_onDesktop
                ? "Hide Filters"
                : "Show Filters"}
            </p>
          </button>
        </div>
        <div className="right">
          <p
            aria-label={`Displaying ${productCount} item${
              productCount === 1 ? "" : "s"
            }`}
            className="product-count"
          >
            Displaying {productCount} item
            {productCount === 1 ? "" : "s"}
          </p>
          <DesktopSorting />
        </div>
      </div>
    </div>
  );
};
